/**
* In this file use to contains the Header Template Sidebar Template and Main Content Template screens
**/
import { Outlet,useNavigate } from "react-router-dom";
import { useEffect,useState } from "react";
import Header from './Header';
import Sidebar from './Sidebar';
import IncomingModal from './../../shared/modals/IncomingModal';
import MessageModal from './../../shared/modals/MessageModal';
import Socket from './../../services/SocketService';
import { useDispatch } from 'react-redux'
import ApiService from './../../services/ApiService';
import PushNotificationsService from './../../services/PushNotificationsService';

function Template() {
	
	//Intial state declaration
   const dispatch = useDispatch();
   const navigate =useNavigate();
   const [popup,setPopup]=useState([]);
   const [message,setMessage]=useState({});
   const pushNotificationsService = PushNotificationsService();
   
   //To check browser notification permssion
	pushNotificationsService.requestPermission();

   /** 
   * To close IncomingModal
   * @room pass the Conneted Socket Room name
   **/
    const handleClose=(room)=>{
		Socket.leaveCall(room);
		setPopup(prevPopup=>prevPopup.filter(i=>i.room !==room));
	};
	
	//To close message modal
	const closeMessage=()=>{
		setMessage({});
	}
	
   //Component Initialize function
   useEffect(()=>{
	
	/** 
	* To trigger(open or close) the IncomingModal
	* @data we get the call status and socket room name in object format
	**/
    Socket.receiveCall((data)=>{
		if(data.status===true){
			setPopup(prevPopup=>[...prevPopup,data]);
		}else{
			Socket.leaveCall(data.room);
			setMessage({show:true,message:'Call Missed'});
			setPopup(popup=>popup.filter(i=>i.room !==data.room));
		}
	});
	
	//To check the token exist or not
	  var token = localStorage.getItem('token');
	     if(!token){
		  navigate('/');
		 } 
   },[navigate]);
   
   //To trigger push notification
   useEffect(()=>{
	   /**
	   * To create browser Push Notifications
	   * @data we pass the source name ,notification receiver user id ,message and module name with Object format
	   **/
		 Socket.listenPushNotification((data) => {
			 if(Object.keys(data).length !==0){
				if(data.source==='message'){
				  pushNotificationsService.generateNotification([{title:data.user,alertContent:'You have new message'}]);
				}else if(data.source==='call'){
				   pushNotificationsService.generateNotification([{title:data.user,alertContent:'You have Incomming call'}]);
				}else if(data.module==='Appointment' || data.module==='Medication' || data.module==='Development Milestones' || data.module==='Vaccination'){
				   pushNotificationsService.generateNotification([{title:'You',alertContent:data.message}]);
				}
			 }
		});
	   
   });
   
   //To call profile GET API and Master Vaccination API
   useEffect(()=>{
	   (async()=>{
		     var response=await ApiService.getProfile();
		     var masterVaccination=await ApiService.masterVaccination();
		     var masterDevelopment=await ApiService.masterDevelopment();
			 if(response.status===200){
				 localStorage.setItem('userId',response.data.profile.account);
			     dispatch({type:"PROFILE",payload:response.data.profile});
			 }
			 if(masterVaccination.status===200)
				 dispatch({type:"VACCINATION",payload:masterVaccination.data});
			 if(masterDevelopment.status===200)
				 dispatch({type:"DEVELOPMENT",payload:masterDevelopment.data});
	   })();
   },[dispatch]);
   
  return (
   <>
   {/*IncomingModal*/}
   {popup.length !==0 && popup.map((item,i)=>( <IncomingModal key={i} handleClose={handleClose} pop={popup.length} data={item}/>))}
   
   {/*MessageModal*/}
   {Object.keys(message).length !==0 && <MessageModal data={message} handleClose={closeMessage} />}
    <Header />
    <Sidebar />
	<Outlet />
   </>
  );
}

export default Template;
